
import { useEffect, useState } from "react"
// ** Third Party Components
import * as yup from "yup"
import { useFormik } from "formik"
//import Flatpickr from "react-flatpickr"

// ** Reactstrap Imports
import {
  //  Form,
  FormFeedback,
  Input,
  Label,
  Button,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem
} from "reactstrap"
import Select from "react-select"
import { Plus, Minus } from "react-feather"

// ** Styles

const ClienteForm = (props) => {
  function initialValues() {
    if (props.datosCliente?.nombre) {
      return props.datosCliente
    } else {
      return {
        nombre: "",
        edad: "",
        estadoCivil: "",
        domicilio: '',
        telefono: '',
        correo: '',
        genero: '',
        numDependientes: 0,
        dependientes: []
      }
    }
  }
  const validationSchema = () => {
    return yup.object({
      edad: yup
        .number()
        .min(1, 'La edad mínima es de 1 año.')
        .max(120, 'La edad máxima es de 120 años.'),
      correo: yup
        .string()
        .email("Correo invalido"),
      telefono: yup
        .string()
        .matches(
          /^[0-9\-]{10}$/,
          "Teléfono requiere 10 digitos."
        )
    })
  }
  
  const [open, setOpen] = useState('')

  const toggle = id => {
    open === id ? setOpen() : setOpen(id)
  }

  const catalagoEstadoCivil = [
    {
      label: "Soltero",
      value: "Soltero"
    },
    {
      label: "Casado",
      value: "Casado"
    },
    {
      label: "Unión libre",
      value: "Unión libre"
    }
  ]
  const catalogoGenero = [
    {
      label: "Masculino",
      value: "Masculino"
    },
    {
      label: "Femenino",
      value: "Femenino"
    },
    {
      label: "Otro",
      value: "Otro"
    }
  ]
  const [numDependientes, setNumDependientes] = useState(0)
  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    onSubmit: (data, { resetForm }) => {}
  })
  
  useEffect(() => {
    formik.setFieldValue("numDependientes", numDependientes)
    // Actualiza arreglo de edades del formik
    if (numDependientes > formik.values.dependientes.length) {
      formik.setFieldValue("dependientes", [...formik.values.dependientes, {edad:'', genero:''}])
    } else {
      // Decremento numDependientes
      const nuevoArray = [...formik.values.dependientes]
      nuevoArray.splice(numDependientes, 1)
      formik.setFieldValue("dependientes", nuevoArray)
    }
    return () => {}
  }, [numDependientes])

  useEffect(() => {

    props.setdatosCliente(formik.values ?? {})
  }, [formik.values])

  return (
  <div>
    <h2>Datos del contratante</h2>

  <div className="d-flex flex-wrap ">
    
    <div className="col-12 col-md-4 w-input mb-1">
        <Label className="form-label" for="tipo">
          Nombre o razón social:
        </Label>
        <Input
          type="text"
          value={formik.values.nombre}
          onChange={(e) => {
            formik.setFieldValue("nombre", e.target.value)
          }}
        />
        {formik.errors.nombre && (
          <FormFeedback>{formik.errors.nombre}</FormFeedback>
        )}
    </div>
    <div className="col-12 col-md-4 w-input mb-1">
        <Label className="form-label" for="tipo">
          Edad:
        </Label>
        <Input
          type="number"
          invalid={formik.errors.edad && true}
          value={formik.values.edad}
          onChange={(e) => {
            formik.setFieldValue("edad", e.target.value)
          }}
        />
        {formik.errors.edad && (
          <FormFeedback>{formik.errors.edad}</FormFeedback>
        )}
    </div>
    <div className="col-12 col-md-4 w-input mb-1">
        <Label className="form-label" for="tipo">
          Estado civil:
        </Label>
        <Select
          className="react-select"
          classNamePrefix="select"
          defaultValue={catalagoEstadoCivil[0]}
          value={{
            label: formik.values.estadoCivil,
            value: formik.values.estadoCivil
          }}
          options={catalagoEstadoCivil}
          isClearable={false}
          onChange={(e) => {
            formik.setFieldValue("estadoCivil", e.value)
          }}
        />
        {formik.errors.estadoCivil && (
          <FormFeedback>{formik.errors.estadoCivil}</FormFeedback>
        )}
    </div>
    <div className="col-12 col-md-8 w-input mb-1">
        <Label className="form-label" for="tipo">
          Domicilio:
        </Label>
        <Input
          value={formik.values.domicilio}
          invalid={formik.errors.domicilio && true}
          onChange={(e) => {
            formik.setFieldValue("domicilio", e.target.value)
          }}
        />
        {formik.errors.domicilio && (
          <FormFeedback>{formik.errors.domicilio}</FormFeedback>
        )}
    </div>
    <div className="col-12 col-md-4 w-input mb-1">
        <Label className="form-label" for="tipo">
          Teléfono:
        </Label>
        <Input
          type="number"
          invalid={formik.errors.telefono && true}
          value={formik.values.telefono}
          onChange={(e) => {
            formik.setFieldValue("telefono", e.target.value)
          }}
        />
        {formik.errors.telefono && (
          <FormFeedback>{formik.errors.telefono}</FormFeedback>
        )}
    </div>
    <div className="col-12 col-md-8 w-input mb-1">
        <Label className="form-label" for="tipo">
          Correo electronico:
        </Label>
        <Input
          invalid={formik.errors.correo && true}
          value={formik.values.correo}
          onChange={(e) => {
            formik.setFieldValue("correo", e.target.value)
          }}
        />
        {formik.errors.correo && (
          <FormFeedback>{formik.errors.correo}</FormFeedback>
        )}  
    </div>
    <div className="col-12 col-md-4 w-input mb-1">
        <Label className="form-label" for="tipo">
          Género:
        </Label>
        <Select
          className="react-select"
          classNamePrefix="select"
          defaultValue={catalogoGenero[0]}
          value={{
            label: formik.values.genero,
            value: formik.values.genero
          }}
          options={catalogoGenero}
          isClearable={false}
          onChange={(e) => {
            formik.setFieldValue("genero", e.value)
          }}
        />
        {formik.errors.genero && (
          <FormFeedback>{formik.errors.genero}</FormFeedback>
        )}
    </div>
    <div className="col-12 col-md-12 mb-1">
      <Label className="form-label" htmlFor="numPasajeros">
        Dependientes:
      </Label>
      <div className="d-flex">
        <Button
          className="round"
          color="success"
          size="sm"
          onClick={
            numDependientes > 0
              ? () => {
                  setNumDependientes(numDependientes - 1)
                }
              : () => {
                  setNumDependientes(numDependientes)
                }
          }
        >
          {" "}
          <Minus />{" "}
        </Button>
        <Input
          onChange={(e) => {
            formik.setFieldValue("numDependientes", e.target.value)
          }}
          value={formik.values.numDependientes}
          style={{ width: "70px" }}
          className="mx-1 text-center text-dark"
          type="number"
        />
        <Button
          className="round"
          color="success"
          size="sm"
          onClick={() => {
            setNumDependientes(numDependientes + 1)
          }}
        >
          {" "}
          <Plus />{" "}
        </Button>
        </div>
    </div>
    <Accordion className='accordion-border col-12 mb-2' open={open} toggle={toggle}>
      
    {formik.values.dependientes.length > 0 &&
      formik.values.dependientes.map((_dependiente, index) => (
        
      <AccordionItem className="col-12">
        <AccordionHeader className="mb-0" targetId={index}>Dependiente # {index + 1}</AccordionHeader>
        <AccordionBody accordionId={index}>
        <div className="col-12 d-flex flex-wrap">
          <div className="col-12 col-md-6 w-input ">
              <Label className="form-label" for="tipo">
                Nombre:
              </Label>
              <Input
                type="text"
                value={formik.values.dependientes[index].nombre}
                onChange={(e) => {
                  formik.setFieldValue(`dependientes[${index}].nombre`, e.target.value)
                }}
              />
          </div>
          <div className="col-12 col-md-3 w-input">
              <Label className="form-label" for="tipo">
                Edad:
              </Label>
              <Input
                type="number"
                // invalid={formik.errors.dependientes[index].edad && true}
                value={formik.values.dependientes[index].edad}
                onChange={(e) => {
                  formik.setFieldValue(`dependientes[${index}].edad`, e.target.value)
                }}
              />
          </div>
          <div className="col-12 col-md-3 w-input">
              <Label className="form-label" for="tipo">
                Genero:
              </Label>
              <Select
                className="react-select"
                classNamePrefix="select"
                defaultValue={catalogoGenero[0]}
                value={{
                  label: formik.values.dependientes[index].genero,
                  value: formik.values.dependientes[index].genero
                }}
                options={catalogoGenero}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue(`dependientes[${index}].genero`, e.value)
                }}
              />
          </div>
        </div>
        </AccordionBody>
      </AccordionItem>
      ))}
    </Accordion>

    </div>
    </div>
    )
}

export default ClienteForm
